function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg data-prefix="fal" data-icon="ellipsis-v" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 512" className={(styles["svg-inline--fa"] || "svg-inline--fa") + " " + (styles["fa-ellipsis-v"] || "fa-ellipsis-v") + " " + (styles["fa-w-2"] || "fa-w-2") + " " + (styles["fa-3x"] || "fa-3x")} {...props}><path fill="#4A4A4A" d="M32 224c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM0 136c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm0 240c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32z" /></svg>;
});